import React from 'react';
import * as S from './References.styles';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>&copy; Organizza 2024.</S.Text>
    </S.ReferencesWrapper>
  );
};
